import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Divider } from '@mui/material';

import { hasProjectHierarchyFeatureFlag } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { handleStandardSceneItemEditPropertiesAction } from '../../../../store/actions/sceneInteractionActions';
import { getAllBuildingsDictionary } from '../../../../store/selectors/layoutDataSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';
import { AnalyzeAllChangedMenuItem } from '../shared-menu-items/AnalyzeAllChangedMenuItem';
import { DeleteMenuItem } from '../shared-menu-items/DeleteMenuItem';
import { LockOptionsSubMenu } from '../shared-menu-items/LockOptionsSubMenu';
import { SettingsSubMenu } from '../shared-menu-items/SettingsSubMenu';

export function BuildingMenu(props: { guid: string }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const building = useAppSelector((state) => getAllBuildingsDictionary(state)[props.guid]);
  const projectHierarchyModificationEnabled = useAppSelector(hasProjectHierarchyFeatureFlag);

  if (building == null) return null;

  return (
    <SceneMenuContent>
      <SceneMenuItem
        text="Edit Properties"
        icon={<EditIcon />}
        onClick={() => {
          dispatch(handleStandardSceneItemEditPropertiesAction('building', building));
          monitor.recordInteraction('Building => Edit Properties menu item clicked');
        }}
      />

      <LockOptionsSubMenu type="building" guid={props.guid} />
      <SettingsSubMenu entry={{ type: 'building', item: building }} />

      <Divider />

      <AnalyzeAllChangedMenuItem type="building" modelGuid={props.guid} />

      {projectHierarchyModificationEnabled && (
        <>
          <Divider />

          <DeleteMenuItem type="building" item={building} />
        </>
      )}
    </SceneMenuContent>
  );
}
